import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from '@/utils';
import goodsDrawer from './goods_drawer.vue';
import empty from '../empty.vue';
import { getDecorationList } from '../../api';
export default {
  name: 'movie_nav',
  components: {
    goodsDrawer: goodsDrawer,
    empty: empty
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    styleId: [Number, String]
  },
  data: function data() {
    return {
      isEmpty: isEmpty,
      activeTab: 'ciname'
      // movieList: [], //电影热映列表
      // cinameList: [] //影院列表
    };
  },
  methods: {
    tabChange: function tabChange(e, tab) {
      e.preventDefault();
      e.stopPropagation();
      this.activeTab = tab.type;
    },
    loadData: function loadData(params) {
      var _this = this;
      var _this$$route$query$te = this.$route.query.temp_id,
        temp_id = _this$$route$query$te === void 0 ? '' : _this$$route$query$te;
      var module = this.info.module;
      getDecorationList(_objectSpread({
        style_id: this.styleId,
        is_template: temp_id && !['cur', 'new'].includes(temp_id) ? 1 : 0
      }, params), module).then(function (res) {
        _this.$set(_this.value, params.type + 'List', res.data);
        // this[params.type + 'List'] = res.data
      });
    }
  },
  created: function created() {
    var _this2 = this;
    var _this$value = this.value,
      key = _this$value.key,
      unique_id = _this$value.unique_id;
    if (unique_id && this.styleId) {
      // this.loadData({ key, unique_id })
      this.value.config.value.forEach(function (item) {
        _this2.loadData({
          type: item.type,
          key: key,
          unique_id: unique_id
        });
      });
    }
  },
  computed: {
    tabList: function tabList() {
      var _list$;
      var list = this.value.config.value.filter(function (i) {
        return Boolean(i.status);
      });
      this.activeTab = (_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.type;
      return list;
    }
  }
};